import ICU from 'i18next-icu'
import { i18n } from '../../../next-i18next.config'

export default {
  i18n,
  fallbackLng: {
    default: ['en'],
    'en-jp': ['en'],
    'ja-jp': ['ja'],
    jp: ['ja'],
  },
  nonExplicitSupportedLngs: true,
  defaultNS: 'common',
  use: [ICU],
  serializeConfig: false,
}
